var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_visualizza",
    "data-name": "icona visualizza",
    transform: "translate(-801.5 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_visualizza-2",
    "data-name": "icona visualizza",
    transform: "translate(-558 -1105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_248",
    "data-name": "Tracciato 248",
    d: "M1.5,14S5.318,6,12,6s10.5,8,10.5,8S18.682,22,12,22,1.5,14,1.5,14Z",
    transform: "translate(1358.5 1123)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_249",
    "data-name": "Tracciato 249",
    d: "M19.227,16.5a2.867,2.867,0,1,1-2.864-3A2.934,2.934,0,0,1,19.227,16.5Z",
    transform: "translate(1354.137 1120.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_772",
    "data-name": "Rettangolo 772",
    transform: "translate(802 21)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.ea05d4c565666ea9e51a5bc9eb4f6b6c.svg";
export { ForwardRef as ReactComponent };